// extracted by mini-css-extract-plugin
export default {"vertical":"RadioGroup_vertical__3rMYt"};